import React from "react";

const Legend = () => {
  const legendStyle = {
    position: "absolute",
    top: "10px",
    right: "10px",
    backgroundColor: "white",
    padding: "10px",
    borderRadius: "5px",
    boxShadow: "0 2px 5px rgba(0, 0, 0, 0.3)",
    zIndex: 1000,
  };

  const itemStyle = {
    display: "flex",
    alignItems: "center",
    marginBottom: "5px",
  };

  const colorBoxStyle = (color, isHollow = false) => ({
    width: "20px",
    height: "20px",
    backgroundColor: isHollow ? "transparent" : color,
    border: isHollow ? "2px solid grey" : "none",
    marginRight: "10px",
  });

  return (
    <div style={legendStyle}>
      <div style={itemStyle}>
        <div style={colorBoxStyle("yellow")}></div>
        <span>Flood-prone area</span>
      </div>
      <div style={itemStyle}>
        <div style={colorBoxStyle("red")}></div>
        <span>Flood risk area</span>
      </div>
      <div style={itemStyle}>
        <div style={colorBoxStyle("grey", true)}></div>
        <span>Buildings</span>
      </div>
    </div>
  );
};

export default Legend;
